import { render, staticRenderFns } from "./SetupServices.vue?vue&type=template&id=7ece904d&scoped=true&"
import script from "./SetupServices.vue?vue&type=script&lang=js&"
export * from "./SetupServices.vue?vue&type=script&lang=js&"
import style0 from "./SetupServices.vue?vue&type=style&index=0&id=7ece904d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ece904d",
  null
  
)

export default component.exports